import { render, staticRenderFns } from "./TargetAndReward.vue?vue&type=template&id=39f5bfc9&scoped=true&"
import script from "./TargetAndReward.vue?vue&type=script&lang=js&"
export * from "./TargetAndReward.vue?vue&type=script&lang=js&"
import style0 from "./TargetAndReward.vue?vue&type=style&index=0&id=39f5bfc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f5bfc9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f5bfc9')) {
      api.createRecord('39f5bfc9', component.options)
    } else {
      api.reload('39f5bfc9', component.options)
    }
    module.hot.accept("./TargetAndReward.vue?vue&type=template&id=39f5bfc9&scoped=true&", function () {
      api.rerender('39f5bfc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/MonthlyShort/components/TargetAndReward.vue"
export default component.exports